export default {"src":"/_next/static/media/byteex_mobile_enquirenow.15748aab.svg","height":20,"width":21};